import StoresPage from 'components/pages/Stores';

import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getSuggestedSearchKeywordsList } from 'services/search';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LINKS from 'constants/links';

const Stores = (props) => <StoresPage {...props} />;

export const getServerSideProps = async () => {
  try {
    const [
      stores,
      recommended,
      categories,
      topbarStores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getStoresList(),
      {
        fn: getSuggestedSearchKeywordsList({ withOffers: true }),
        fallback: { recommendedOffers: [] },
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        featuredOffers: recommended.recommendedOffers,
        stores,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores: topbarStores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[500], permanent: false } };
  }
};

export default Stores;
